import { useEffect } from "react";
import Api from "../../api/Api"
import exportToExcel from "./exportToExcel";
import countByFormulaTotal from "./countByFormulaTotal";
import ExcelTableDataTransform from "./ExcelTableDataTransform";

const jsonData = {
  users: [
    { id: 1, name: 'Иван', email: 'ivan@example.com', age: 25 },
    { id: 2, name: 'Мария', email: 'maria@example.com', age: 30 },
    { id: 3, name: 'Петр', email: 'petr@example.com', age: 28 }
  ],
  products: [
    { id: 1, name: 'Ноутбук', price: 50000, category: 'Электроника' },
    { id: 2, name: 'Смартфон', price: 30000, category: 'Электроника' },
    { id: 3, name: 'Книга', price: 500, category: 'Литература' }
  ],
  orders: [
    { id: 1, userId: 1, productId: 1, quantity: 1, date: '2024-01-15' },
    { id: 2, userId: 2, productId: 2, quantity: 2, date: '2024-01-16' }
  ]
};


const prepareTableData = (results,testData) => {
    const count_measure=countByFormulaTotal(results.results, results.coefficients);
    const result=ExcelTableDataTransform(results, testData, count_measure)
    return result;
}

export const downloadExcelAuditResults = (audit_id) => {
    const getResultsAudit = async(audit_id) => {
        try {
            const response = await Api({
                method:"get",
                url:`/audits/@${audit_id}/results`,
                headers:{}
            })
            return(response.data)
        } catch (error) {
            throw `Ошибка при подгрузке результатов аудита ${audit_id}`;
        }
    }

    const getTest = async(testId) => {
        try {
            const response = await Api({
                method:"get",
                url:`/tests/@${testId}`,
                headers:{}
            })
            return(response.data)
        } catch (error) {
            throw `Ошибка при подгрузке теста \n ${testId}`
        }
    }

    const mainFunc = async() => {
        try {
            const results = await getResultsAudit(audit_id);
            const testData= await getTest(results.test_id);
            const result = prepareTableData(results,testData);
            exportToExcel(result, `отчёт ${results.name || "название по умолчанию"}` );
        } catch (error) {
            alert(error);
        }
    }

    return(mainFunc())
}